import {
  COMMON_HEADING_TRANSLATIONS,
  COMMON_TABLE_COLUMNS,
  CommonTable,
} from '../../../TableCells/data';

export type DataRoomInvitationsTable = CommonTable &
  Record<'createdAt', string>;

export const TABLE_COLUMNS: Array<keyof DataRoomInvitationsTable> = [
  ...COMMON_TABLE_COLUMNS,
  'createdAt',
];

export const HEADING_TRANSLATIONS = {
  ...COMMON_HEADING_TRANSLATIONS,
  createdAt: 'invited',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  createdAt: 'createdAt',
};
